// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  width: 100%;
  height: 100%;
  scroll-behavior: smooth !important;
  scrollbar-width: thin !important;
  scrollbar-color: #1a1a1a #1a1a1a !important;
}
a {
  text-decoration: none;
  color: inherit;
}

.generalInputContainer {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  width: 100%;
}

.labelText {
  font-family: "Inter", sans-serif;
  font-size: 14.5px;
  font-weight: 500;
  line-height: 20px;
  color: #e2e8f0;
  letter-spacing: 0.2px;
}

.inputContainerWrapper {
  position: relative;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.12);
  width: clamp(300px, 31.5vw, 460px);
  height: 54px;
  border-radius: 12px;
  box-sizing: border-box;
  padding-left: 18px;
  padding-right: 48px;
  font-family: "Inter", sans-serif;
  font-size: 15.5px;
  font-weight: 400;
  backdrop-filter: blur(8px);
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  display: flex;
  align-items: center;
  margin-bottom: 0;
}

.inputContainerWrapper:hover {
  background: rgba(255, 255, 255, 0.06);
  border-color: rgba(255, 255, 255, 0.25);
}

.inputContainerWrapper:focus-within {
  background: rgba(14, 28, 30, 0.85);
  border-color: #48d1cc;
  box-shadow: 0 0 0 3.5px rgba(72, 209, 204, 0.18), 0 4px 20px rgba(0, 0, 0, 0.4);
}

.input {
  all: unset;
  width: 100%;
  height: 100%;
  color: #ffffff;
  font-family: "Inter", sans-serif;
  font-size: 15px;
  font-weight: 400;
  box-sizing: border-box;
}

.input::placeholder {
  color: #6b7280;
  font-size: 14px;
  font-weight: 400;
  opacity: 1;
}

.inputText {
  font-family: "Inter", sans-serif;
  font-size: 15px;
  font-weight: 400;
  color: #ffffff;
}

.errorTooltip {
  position: relative;
  top: 100%;
  left: 0;
  font-size: 12px;
  margin-top: 4px;
  white-space: wrap;
  z-index: 10;
  pointer-events: none;
}

/* Unified tooltip variants for messages below inputs */
.tooltipMessage {
  display: inline-block;
  padding: 6px 10px;
  border-radius: 6px;
  line-height: 1.2;
}

.tooltipSuccess {
  background-color: #22c55e;
  color: #ffffff;
}

.tooltipError {
  background-color: #ef4444;
  color: #ffffff;
}

.eyeIcon {
  position: absolute;
  top: 50%;
  right: 14px;
  transform: translateY(-50%);
  background: none;
  border: none;
  color: #808080;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  transition: color 0.2s ease, transform 0.15s ease;
  z-index: 10;
}

.eyeIcon:hover {
  color: #48d1cc;
}

input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
input:-webkit-autofill:active {
  -webkit-text-fill-color: #ffffff !important;
  caret-color: #ffffff !important;
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-transition: background-color 5000000s ease-in-out 0s, color 5000000s ease-in-out 0s;
  transition: background-color 5000000s ease-in-out 0s, color 5000000s ease-in-out 0s;
  box-shadow: none !important;
  -webkit-box-shadow: none !important;
}

/* Mobile responsive styles for input fields */
@media (max-width: 768px) {
  .generalInputContainer {
    gap: 8px;
    width: 100%;
  }
  .inputContainerWrapper {
    width: 100% !important;
    max-width: 100%;
    height: 48px;
    border-radius: 12px;
    padding-left: 16px;
    padding-right: 46px;
    font-size: 15px;
    box-sizing: border-box;
  }
}

`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAEA;EACE,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,gCAAgC;EAChC,2CAA2C;AAC7C;AACA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,qCAAqC;EACrC,2CAA2C;EAC3C,kCAAkC;EAClC,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,kDAAkD;EAClD,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;AACzC;;AAEA;EACE,kCAAkC;EAClC,qBAAqB;EACrB,+EAA+E;AACjF;;AAEA;EACE,UAAU;EACV,WAAW;EACX,YAAY;EACZ,cAAc;EACd,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,oBAAoB;AACtB;;AAEA,uDAAuD;AACvD;EACE,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,2BAA2B;EAC3B,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,iDAAiD;EACjD,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;;;;EAIE,2CAA2C;EAC3C,+BAA+B;EAC/B,6BAA6B;EAC7B,qBAAqB;EACrB,2FAAmF;EAAnF,mFAAmF;EACnF,2BAA2B;EAC3B,mCAAmC;AACrC;;AAEA,8CAA8C;AAC9C;EACE;IACE,QAAQ;IACR,WAAW;EACb;EACA;IACE,sBAAsB;IACtB,eAAe;IACf,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,sBAAsB;EACxB;AACF","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap\");\n\n.App {\n  width: 100%;\n  height: 100%;\n  scroll-behavior: smooth !important;\n  scrollbar-width: thin !important;\n  scrollbar-color: #1a1a1a #1a1a1a !important;\n}\na {\n  text-decoration: none;\n  color: inherit;\n}\n\n.generalInputContainer {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 8px;\n  width: 100%;\n}\n\n.labelText {\n  font-family: \"Inter\", sans-serif;\n  font-size: 14.5px;\n  font-weight: 500;\n  line-height: 20px;\n  color: #e2e8f0;\n  letter-spacing: 0.2px;\n}\n\n.inputContainerWrapper {\n  position: relative;\n  background: rgba(255, 255, 255, 0.04);\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  width: clamp(300px, 31.5vw, 460px);\n  height: 54px;\n  border-radius: 12px;\n  box-sizing: border-box;\n  padding-left: 18px;\n  padding-right: 48px;\n  font-family: \"Inter\", sans-serif;\n  font-size: 15.5px;\n  font-weight: 400;\n  backdrop-filter: blur(8px);\n  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);\n  display: flex;\n  align-items: center;\n  margin-bottom: 0;\n}\n\n.inputContainerWrapper:hover {\n  background: rgba(255, 255, 255, 0.06);\n  border-color: rgba(255, 255, 255, 0.25);\n}\n\n.inputContainerWrapper:focus-within {\n  background: rgba(14, 28, 30, 0.85);\n  border-color: #48d1cc;\n  box-shadow: 0 0 0 3.5px rgba(72, 209, 204, 0.18), 0 4px 20px rgba(0, 0, 0, 0.4);\n}\n\n.input {\n  all: unset;\n  width: 100%;\n  height: 100%;\n  color: #ffffff;\n  font-family: \"Inter\", sans-serif;\n  font-size: 15px;\n  font-weight: 400;\n  box-sizing: border-box;\n}\n\n.input::placeholder {\n  color: #6b7280;\n  font-size: 14px;\n  font-weight: 400;\n  opacity: 1;\n}\n\n.inputText {\n  font-family: \"Inter\", sans-serif;\n  font-size: 15px;\n  font-weight: 400;\n  color: #ffffff;\n}\n\n.errorTooltip {\n  position: relative;\n  top: 100%;\n  left: 0;\n  font-size: 12px;\n  margin-top: 4px;\n  white-space: wrap;\n  z-index: 10;\n  pointer-events: none;\n}\n\n/* Unified tooltip variants for messages below inputs */\n.tooltipMessage {\n  display: inline-block;\n  padding: 6px 10px;\n  border-radius: 6px;\n  line-height: 1.2;\n}\n\n.tooltipSuccess {\n  background-color: #22c55e;\n  color: #ffffff;\n}\n\n.tooltipError {\n  background-color: #ef4444;\n  color: #ffffff;\n}\n\n.eyeIcon {\n  position: absolute;\n  top: 50%;\n  right: 14px;\n  transform: translateY(-50%);\n  background: none;\n  border: none;\n  color: #808080;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n  transition: color 0.2s ease, transform 0.15s ease;\n  z-index: 10;\n}\n\n.eyeIcon:hover {\n  color: #48d1cc;\n}\n\ninput:-webkit-autofill,\ninput:-webkit-autofill:hover,\ninput:-webkit-autofill:focus,\ninput:-webkit-autofill:active {\n  -webkit-text-fill-color: #ffffff !important;\n  caret-color: #ffffff !important;\n  -webkit-background-clip: text;\n  background-clip: text;\n  transition: background-color 5000000s ease-in-out 0s, color 5000000s ease-in-out 0s;\n  box-shadow: none !important;\n  -webkit-box-shadow: none !important;\n}\n\n/* Mobile responsive styles for input fields */\n@media (max-width: 768px) {\n  .generalInputContainer {\n    gap: 8px;\n    width: 100%;\n  }\n  .inputContainerWrapper {\n    width: 100% !important;\n    max-width: 100%;\n    height: 48px;\n    border-radius: 12px;\n    padding-left: 16px;\n    padding-right: 46px;\n    font-size: 15px;\n    box-sizing: border-box;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
